import { modal, toast } from '@mx/vix';
import { bridge } from '../bridge';

export enum CommonErrorLevel {
  TOAST = 1, // level 1: toast 报错，留在当前页
  MODAL_EXIT, // level 2: 退出美团支付（Native 的概念里切卡不属于美团支付）
  MODAL, // level 3: 弹窗提示报错，点击知道了留在当前页
  EXIT, // level 4: 退出美团支付 + 收银台，聚合侧不会返回 level 2
  INLINE, // level 5: 页内展示，会定位到相应元素上
  REFRESH, // level 6: 刷新收银台，同时 dispatcher 接口增加 dispatcher_scene = 'meituanpay_fail';
}

export class CommonError extends Error {
  static isCommonError(error: any): error is CommonError {
    return error?.name === 'CommonError';
  }

  static handleCommonError(error: CommonError): void {
    const { code, level, message } = error;
    let msg = message;

    if (level !== CommonErrorLevel.INLINE) {
      msg += `<span class="error-code">(${code})</span>`;
    }

    switch (level) {
      case CommonErrorLevel.TOAST:
        toast.toast('text', msg);
        break;
      case CommonErrorLevel.MODAL_EXIT: // level 2: 退出美团支付（切卡不属于美团支付）
      case CommonErrorLevel.EXIT: // level 4: 退出美团支付 + 收银台，聚合侧不会返回 2 可以和 4 一起处理
        // const result = (error.code === '117003') ? 'success' : 'fail';  //117003 => 订单已支付
        modal.show({
          preventScroll: true,
          title: '提示',
          content: msg,
          button: {
            text: '知道了',
            onClick: () => {
              bridge.closeWebview();
            },
          },
        });
        // TODO stat
        // analytics.viewWithCid(commonBids.busiErrorModalShow, {
        //   error_level: level,
        //   modal_content: msg,
        // });
        break;
      case CommonErrorLevel.MODAL:
        modal.show({
          preventScroll: true,
          content: msg,
          button: {
            text: '知道了',
            onClick: () => {
              modal.hide();
            },
          },
        });
        // TODO stat
        // analytics.viewWithCid(commonBids.busiErrorModalShow, {
        //   error_level: level,
        //   modal_content: msg,
        // });
        break;
      case CommonErrorLevel.INLINE:
      case CommonErrorLevel.REFRESH:
        // 埋点
        break;
      default:
    }
  }

  name: string = 'CommonError';

  code: string;

  level: CommonErrorLevel;

  constructor(code: string, level: CommonErrorLevel, message: string) {
    super(message);

    this.code = code;
    this.level = level;
  }
}
